<template>
  <div class="container text-center pb-5 mt-5">
    <h1 class="text-uppercase mt-5 mb-3 d-none">Upload your receipt</h1>
    <p class="d-none">Take a clear photo of the whole receipt, showing all 4 corners. Use a plain surface with good light. Ensure the store name, purchase date, cereal products, prices and total receipt amount are all readable. You can select up to 5 photos to capture one full receipt. 
<br>
Submit within 30 days of purchase. 
</p>
    <div class="mb-5">
      <section class="wrapper">
        <component :is="WidgetComponent" campaign-id="5acf9437-30f9-4a8b-a405-541317808df8"></component>
      </section>
    </div>
    
  </div>
</template>

<script>
import CampaignWidgets from '../Home/Homepagecomponents/CampaignWidgets.vue';

export default {
  components: { CampaignWidgets },
  props: {

  },
  data() {
    return {
      showComponent: false,
      WidgetComponent: CampaignWidgets,
    };
  },
};
</script>
